import axios from 'axios';

import authenticationService from 'services/AuthenticationService';

const request = {
  get(headers, url, params) {
    const configOptions = {
      params,
      headers,
    };

    const apiCallPromis = axios.get(url, configOptions);
    return apiCallPromis;
  },

  post(headers, url, params) {
    const configOptions = {
      headers,
    };

    const apiCallPromis = axios.post(url, params, configOptions);
    return apiCallPromis;
  },

  put(headers, url, params) {
    const configOptions = {
      headers,
    };

    const apiCallPromis = axios.put(url, params, configOptions);
    return apiCallPromis;
  },

  delete(headers, url, params) {
    const configOptions = {
      headers,
    };

    const apiCallPromis = axios.delete(url, params, configOptions);
    return apiCallPromis;
  },

  patch(headers, url, params) {
    const configOptions = {
      headers,
    };

    const apiCallPromis = axios.patch(url, params, configOptions);
    return apiCallPromis;
  },
};

const wrap =
  method =>
  // eslint-disable-next-line consistent-return
  async (customHeaders = {}, replaceHeaders = false, ...props) => {
    // Use unified authentication service
    const { isValidUser, token } = await authenticationService.validateUser();

    if (isValidUser && token) {
      let headers = {
        authorization: `Bearer ${token}`,
        ...customHeaders,
      };
      if (replaceHeaders) headers = customHeaders;

      return request[method](headers, ...props);
    }

    // Handle authentication failure
    if (authenticationService.isEmbeddedMode()) {
      // In embedded mode, don't redirect, just throw error
      throw new Error('No authentication token available in embedded mode');
    } else {
      // In standalone mode, redirect to login
      document.location.href = '/login';
    }
  };

export const get = wrap('get');
export const post = wrap('post');
export const put = wrap('put');
export const patch = wrap('patch');
export const del = wrap('delete');
